import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/taks-01/task";

const lesson: Lesson = {
  id: "40eb00fe-75c3-44e5-b0c3-81387e9f1cc5",
  publicId: "15",
  name: "Solutions of wave equation in spherical coordinates",
  difficulty: 3,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
